const initialState = {
  data: null,
  loading: null,
  error: null,
};

export default initialState;
